global.jQuery = require('jquery');
global.$ = jQuery;

import ajaxCart from './components/ajax-cart';
import homePage from './pages/home';
import productPage from './pages/product';
import collectionPage from './pages/collection';
import artistsPage from './pages/artists';
import Cart from './pages/cart';
import shopifyMoney from './extra/money';
import Wishlist from './components/wishlist';
import './lib/shopify-products';

const { detect } = require('detect-browser');
const browser = detect();

var ipadOS = navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform);

global.isTouch = (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0));

const colourOptions = [
    '#d7d029',
    '#7fb6d9',
    '#ff4841',
    '#46ba67',
    '#eb88c8',
    '#ff7600'
];

const rebindWishlistHearts = () => {
    const bind = () => {
        if (window.wishlist && typeof window.wishlist.binds === 'function') {
            window.wishlist.binds();

            if (typeof window.wishlist.updateWishlist === 'function') {
                window.wishlist.updateWishlist();
            }
        }
    };

    if (window.wishlist) {
        bind();
        return;
    }

document.addEventListener('wishlist:ready', () => {
    bind();
}, { once: true });
};

const escapeHtml = (value = '') => {
    return value.replace(/[&<>"'`]/g, (match) => {
        const escapes = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '`': '&#96;'
        };
        return escapes[match] || match;
    });
};

const coerceMetafieldValue = (metafield) => {
    if (metafield === null || typeof metafield === 'undefined') {
        return null;
    }
    if (typeof metafield === 'object' && 'value' in metafield) {
        return metafield.value;
    }
    return metafield;
};

const interpretBooleanFlag = (value) => {
    if (value === true || value === 1 || value === '1') {
        return true;
    }
    if (value === false || value === 0 || value === '0') {
        return false;
    }
    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        if (['true', 'yes', '1'].includes(normalized)) {
            return true;
        }
        if (['false', 'no', '0'].includes(normalized)) {
            return false;
        }
    }
    return null;
};

const normalizeImageInput = (image) => {
    if (!image) {
        return '';
    }
    if (typeof image === 'string') {
        return image;
    }
    if (typeof image === 'object' && typeof image.src === 'string') {
        return image.src;
    }
    return '';
};

const buildRecentlyViewedCard = (product, assets = {}) => {
    if (!product) {
        return '';
    }

    const heartIcon = assets.heart || '';
    const heartFillIcon = assets.heartFill || heartIcon;
    const handle = product.handle || '';
    const productUrl = product.url || `/products/${handle}`;
    const vendor = escapeHtml(product.vendor || '');
    const title = escapeHtml(product.title || '');
    const rawTags = Array.isArray(product.tags) ? product.tags : [];
    const tags = rawTags.length ? escapeHtml(rawTags.join(' ')) : '';
    const primaryImage = product.featured_image || (product.images && product.images[0]);
    const resizedImage = primaryImage && window.Shopify && Shopify.Products && typeof Shopify.Products.resizeImage === 'function'
        ? Shopify.Products.resizeImage(primaryImage, '720x720')
        : null;
    const fallbackImage = normalizeImageInput(primaryImage);
    const sourceImage = resizedImage || fallbackImage;
    const imageSrc = sourceImage ? (sourceImage.startsWith('//') ? `https:${sourceImage}` : sourceImage) : '';
    const priceValue = typeof product.price === 'number' ? product.price : 0;
    const price = (window.Shopify && typeof Shopify.formatMoney === 'function')
        ? Shopify.formatMoney(priceValue, window.Shopify.money_format)
        : `$${(priceValue / 100).toFixed(2)}`;
    const reservedMetafield = product && product.metafields && product.metafields.custom
        ? product.metafields.custom.reserved
        : null;
    const reservedFlag = interpretBooleanFlag(coerceMetafieldValue(reservedMetafield));
    const normalizedTags = rawTags
        .map((tag) => (typeof tag === 'string' ? tag.trim().toLowerCase() : ''))
        .filter(Boolean);
    const pendingOrderTags = ['ordered', 'committed'];
    const hasPendingOrder = reservedFlag !== null
        ? reservedFlag
        : normalizedTags.some((tag) => pendingOrderTags.includes(tag));
    const availabilityDotClass = product.available === false
        ? (hasPendingOrder ? 'yellow-dot' : 'red-dot')
        : '';
    const availabilityDot = availabilityDotClass ? `<span class="${availabilityDotClass}"></span>` : '';

    const heartMarkup = heartIcon ? `
        <a href="#" class="heart" data-product-id="${handle}">
            <span class="heart-ico"><img src="${heartIcon}" alt="" loading="lazy"></span>
            <span class="heart-ico fill"><img src="${heartFillIcon}" alt="" loading="lazy"></span>
        </a>
    ` : '';

    return `
        <article class="product-item" data-id="${handle}" data-price="${(priceValue / 100).toFixed(2)}" data-themes="${tags}">
            <a class="product-item--link" href="${productUrl}">
                ${imageSrc ? `<img src="${imageSrc}" alt="${title}" loading="lazy" width="533" height="533">` : ''}
                <div class="product-item--info">
                    <h4>${vendor}</h4>
                    <h3>${title}</h3>
                    <p class="product-price">${price}${availabilityDot}</p>
                    ${heartMarkup}
                </div>
                <span class="product-item--dimensions">Size unknown</span>
            </a>
        </article>
    `.trim();
};

const initDragScrollContainers = () => {
    const containers = document.querySelectorAll('[data-drag-scroll]');

    containers.forEach((container) => {
        if (container.dataset.dragScrollInit === '1') {
            return;
        }

        let pointerActive = false;
        let dragging = false;
        let pointerCaptured = false;
        let activePointerId = null;
        let startX = 0;
        let startY = 0;
        let scrollStart = 0;
        let preventClick = false;
        let preventClickTimer = null;

        const setPreventClick = () => {
            preventClick = true;
            if (preventClickTimer) {
                clearTimeout(preventClickTimer);
            }
            preventClickTimer = setTimeout(() => {
                preventClick = false;
            }, 200);
        };

        const releasePointerCapture = () => {
            if (!pointerCaptured || activePointerId === null) {
                return;
            }
            try {
                container.releasePointerCapture(activePointerId);
            } catch (err) {
                // ignore
            }
            pointerCaptured = false;
        };

        const endPointerTracking = (event, shouldPreventClick) => {
            if (!pointerActive || (activePointerId !== null && event.pointerId !== activePointerId)) {
                return;
            }
            pointerActive = false;

            if (shouldPreventClick && dragging) {
                setPreventClick();
            }

            dragging = false;
            container.classList.remove('is-dragging');
            releasePointerCapture();
            activePointerId = null;
        };

        const pointerDown = (event) => {
            if (!event.isPrimary) return;
            if (event.button !== undefined && event.button !== 0 && event.pointerType !== 'touch') {
                return;
            }

            pointerActive = true;
            dragging = false;
            pointerCaptured = false;
            activePointerId = event.pointerId;
            startX = event.clientX;
            startY = event.clientY;
            scrollStart = container.scrollLeft;
        };

        const pointerMove = (event) => {
            if (!pointerActive || activePointerId !== event.pointerId) {
                return;
            }

            const deltaX = event.clientX - startX;
            const deltaY = event.clientY - startY;
            if (!dragging) {
                if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 6) {
                    endPointerTracking(event, false);
                    return;
                }
                if (Math.abs(deltaX) > 3) {
                    dragging = true;
                    container.classList.add('is-dragging');
                    if (!pointerCaptured) {
                        try {
                            container.setPointerCapture(event.pointerId);
                            pointerCaptured = true;
                        } catch (err) {
                            // ignore
                        }
                    }
                } else {
                    return;
                }
            }

            container.scrollLeft = scrollStart - deltaX;
            if (event.pointerType === 'touch') {
                event.preventDefault();
            }
        };

        const pointerUp = (event) => {
            if (!pointerActive || activePointerId !== event.pointerId) {
                return;
            }
            endPointerTracking(event, true);
        };

        const pointerCancel = (event) => {
            if (!pointerActive || activePointerId !== event.pointerId) {
                return;
            }
            endPointerTracking(event, false);
        };

        const windowPointerUp = (event) => {
            if (!pointerActive || activePointerId !== event.pointerId) {
                return;
            }
            endPointerTracking(event, true);
        };

        const clickGuard = (event) => {
            if (preventClick) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        };

        const dragStart = (event) => {
            if (dragging) {
                event.preventDefault();
            }
        };

        container.addEventListener('pointerdown', pointerDown);
        container.addEventListener('pointermove', pointerMove);
        container.addEventListener('pointerup', pointerUp);
        container.addEventListener('pointercancel', pointerCancel);
        container.addEventListener('click', clickGuard, true);
        container.addEventListener('dragstart', dragStart);

        window.addEventListener('pointerup', windowPointerUp);

        container.dataset.dragScrollInit = '1';
        container._dragScrollCleanup = () => {
            window.removeEventListener('pointerup', windowPointerUp);
            if (preventClickTimer) {
                clearTimeout(preventClickTimer);
            }
        };
    });
};

const initLatestRecentSections = () => {
    const sections = document.querySelectorAll('[data-section-type="latest-recent"]');

    if (!sections.length) {
        return;
    }

    sections.forEach(section => {
        if (section.dataset.latestRecentInit === 'true') {
            return;
        }
        section.dataset.latestRecentInit = 'true';

        const rawLimit = parseInt(section.getAttribute('data-limit'), 10);
        const limit = Number.isFinite(rawLimit) && rawLimit > 0 ? rawLimit : 4;
        const rawMinRecent = parseInt(section.getAttribute('data-recent-min'), 10);
        const minRecent = Number.isFinite(rawMinRecent) && rawMinRecent > 0 ? rawMinRecent : 2;
        const currentHandle = section.getAttribute('data-current-handle');
        const buttons = section.querySelectorAll('.latest-recent__toggle-btn');
        const lists = Array.from(section.querySelectorAll('.latest-recent__list'));
        const recentGrid = section.querySelector('[data-recent-grid]');
        const recentEmpty = section.querySelector('[data-recent-empty]');
        const recentButton = section.querySelector('[data-toggle="recent"]');

        const toggleMap = {};
        lists.forEach(list => {
            const key = list.getAttribute('data-list');
            if (key) {
                toggleMap[key] = list;
            }
        });

        const showList = (list) => {
            if (!list) return;
            list.classList.remove('is-leaving');
            if (list._latestRecentFadeTimer) {
                window.clearTimeout(list._latestRecentFadeTimer);
                delete list._latestRecentFadeTimer;
            }
            if (list._latestRecentHideHandler) {
                list.removeEventListener('transitionend', list._latestRecentHideHandler);
                delete list._latestRecentHideHandler;
            }
            list.hidden = false;
            list.classList.add('is-active');
            list.setAttribute('aria-hidden', 'false');
            requestAnimationFrame(() => {
                list.classList.add('is-visible');
            });
        };

        const hideList = (list) => {
            if (!list || list.classList.contains('is-leaving')) {
                return;
            }

            const completeHide = () => {
                if (list._latestRecentFadeTimer) {
                    window.clearTimeout(list._latestRecentFadeTimer);
                    delete list._latestRecentFadeTimer;
                }
                if (list._latestRecentHideHandler) {
                    list.removeEventListener('transitionend', list._latestRecentHideHandler);
                    delete list._latestRecentHideHandler;
                }
                list.hidden = true;
                list.classList.remove('is-active');
                list.classList.remove('is-leaving');
            };

            const onTransitionEnd = (event) => {
                if (event.target !== list || event.propertyName !== 'opacity') {
                    return;
                }
                completeHide();
            };

            list._latestRecentHideHandler = onTransitionEnd;
            list.classList.add('is-leaving');
            list.classList.remove('is-visible');
            list.setAttribute('aria-hidden', 'true');
            list.addEventListener('transitionend', onTransitionEnd);
            list._latestRecentFadeTimer = window.setTimeout(() => {
                completeHide();
            }, 400);
        };

        const updateButtons = (target) => {
            buttons.forEach(btn => {
                const btnTarget = btn.getAttribute('data-toggle');
                if (btnTarget === target) {
                    btn.classList.add('is-active');
                    btn.setAttribute('aria-selected', 'true');
                } else {
                    btn.classList.remove('is-active');
                    btn.setAttribute('aria-selected', 'false');
                }
            });
        };

        const findInitialKey = () => {
            return Object.keys(toggleMap).find(key => {
                const listEl = toggleMap[key];
                return listEl && listEl.classList.contains('is-active');
            });
        };

        let activeKey = findInitialKey();
        if (!activeKey && toggleMap.latest) {
            activeKey = 'latest';
        }

        if (activeKey && toggleMap[activeKey]) {
            showList(toggleMap[activeKey]);
            updateButtons(activeKey);
            section.dataset.activeList = activeKey;
        }

        const setActive = (target) => {
            if (!toggleMap[target]) {
                return;
            }

            if (activeKey === target) {
                showList(toggleMap[target]);
                updateButtons(target);
                section.dataset.activeList = target;
                return;
            }

            const currentList = activeKey ? toggleMap[activeKey] : null;
            const nextList = toggleMap[target];

            if (currentList) {
                hideList(currentList);
            }

            showList(nextList);
            updateButtons(target);
            activeKey = target;
            section.dataset.activeList = target;
        };

        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                if (btn.classList.contains('is-disabled')) {
                    return;
                }

                const target = btn.getAttribute('data-toggle');
                if (target) {
                    setActive(target);
                }
            });
        });

        if (!recentGrid) {
            return;
        }

        if (!(window.Shopify && Shopify.Products && typeof Shopify.Products.getRecentlyViewedHandles === 'function' && typeof Shopify.Products.fetchProducts === 'function')) {
            return;
        }

        const assetData = {
            heart: section.getAttribute('data-heart-icon') || '',
            heartFill: section.getAttribute('data-heart-fill-icon') || ''
        };

        let storedHandles = Shopify.Products.getRecentlyViewedHandles().filter(Boolean);

        if (storedHandles.length > limit * 3) {
            storedHandles = storedHandles.slice(0, limit * 3);
        }

        if (currentHandle) {
            storedHandles = storedHandles.filter(handle => handle !== currentHandle);
        }

        if (limit && storedHandles.length > limit) {
            storedHandles = storedHandles.slice(0, limit);
        }

        if (!storedHandles.length) {
            return;
        }

        recentGrid.innerHTML = '';

        Shopify.Products.fetchProducts(storedHandles, limit)
            .then((products) => {
                if (!Array.isArray(products) || !products.length) {
                    return;
                }

                const limitedResults = products.slice(0, limit);
                recentGrid.innerHTML = limitedResults.map(product => buildRecentlyViewedCard(product, assetData)).join('');

                if (recentEmpty) {
                    recentEmpty.hidden = true;
                }

                if (recentButton) {
                    recentButton.classList.remove('is-disabled');
                    recentButton.removeAttribute('aria-disabled');
                }

                if (limitedResults.length >= minRecent) {
                    setActive('recent');
                }

                rebindWishlistHearts();
            })
            .catch(() => {
                // swallow errors silently
            });
    });
};

if (ipadOS) {
    $('html').addClass('ipados');
}

if (browser) {
    let b = browser.name.replace(' ', '').toLowerCase();
    $('html').addClass(b);
    $('html').addClass(`${b}_${browser.version}`);
    $('html').addClass(`${b}_${browser.os.replace(' ', '').toLowerCase()}`);
}


$(() => {
    console.log('ok');

    $('.search-container button').on('click', function (e) {
        if ($('.search-input').val() == '') {
            e.preventDefault();
        }
    });

    let popLocal = localStorage.getItem('www-newsletterpopup');
    let now = Date.now();
    let hours48 = 48 * 60 * 60 * 1000; // 48 hours in milliseconds
    let popLoop = null;

    // Check if the popup should be shown
    if (popLocal !== 'never') {
        if (!popLocal || (now - parseInt(popLocal)) > hours48) {
            popLoop = setInterval(function () {
                if ($('#Avada-CookiesBar').children('div').length == 0) {
                    clearInterval(popLoop);
                    $('#newsltr-popup').addClass('in');
                }
            }, 10000);
        }
    }

    $('.newsltr-popup--close').on('click', function (e) {
        e.preventDefault();
        localStorage.setItem('www-newsletterpopup', Date.now());
        $('#newsltr-popup').removeClass('in');
    });

    $('#newsltr-popup .klaviyo-form').on('submit', function () {
        localStorage.setItem('www-newsletterpopup', 'never');
    });

    const money = new shopifyMoney();
    money.init();

    if ($('.template-cart').length > 0) {
        new Cart();
    } else {
        let c = new ajaxCart;
        c.init();
    }

    $('.darkmode-toggle').on('click', function (e) {
        e.preventDefault();
        $('html').toggleClass('dark');
        localStorage.setItem('darkmode', $('html').hasClass('dark'));
        $(this).children('i').toggleClass('cur');
    });

    if (localStorage.getItem('darkmode') == 'true') {
        $('html').addClass('dark');
        $('.darkmode-toggle').children('i').toggleClass('cur');
    }


    // page types
    if ($('.template-index').length > 0) {
        const page = new homePage();
        page.init();
    }


    if ($('.template-suffix-artists').length > 0) {
        const page = new artistsPage();
    }

    if (
        $('.template-collection').length > 0 ||
        $('.template-search').length > 0
    ) {
        const page = new collectionPage();
        page.init();

        if ($('.template-suffix-artist').length > 0) {
            let borderLeft = Math.random() > 0.5 ? 'left' : 'right';
            if (borderLeft == 'left') {
                $('.name img').css({
                    'border-left': `6px solid ${colourOptions[Math.floor(Math.random() * colourOptions.length)]}`
                });
            } else {
                $('.name img').css({
                    'border-right': `6px solid ${colourOptions[Math.floor(Math.random() * colourOptions.length)]}`
                });
            }
        }

        $('[href="#works"]').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $('#works').offset().top - 100
            }, 500);
        });
    }

    setTimeout(() => {
        window.wishlist = new Wishlist();
        wishlist.init();
        document.dispatchEvent(new CustomEvent('wishlist:ready'));
    }, 100);

    if ($('.template-product').length > 0) {
        const page = new productPage();
        page.init();
    }

    initDragScrollContainers();
    initLatestRecentSections();

    document.querySelector('.hypno').addEventListener('click', () => {
        document.querySelector('html').classList.toggle('hypno');
        $('.hypno-text').remove();
        if ($('html').hasClass('hypno')) {
            $('html').append('<div class="hypno-text"><span>OLET NYT TAIDEHYPNOOSISSA</span><span>OLET NYT TAIDEHYPNOOSISSA</span><span>OLET NYT TAIDEHYPNOOSISSA</span></div>');
        }
    });


    if ($('.content-nav').length > 0) {
        $('.default-page > ol > li').each(function () {
            // generate slug
            let slug = $(this).text().toLowerCase().replaceAll(/ /g, '').replaceAll('\n', '');
            $(this).attr('id', slug);
            // create nav
            $('.content-nav').append(`<a href="#${slug}">${$(this).text()}</a>`);
        });
        $('.content-nav a').on('click', function (e) {
            e.preventDefault();
            let target = $(this).attr('href');
            $('html, body').animate({
                scrollTop: $(target).offset().top - 100
            }, 500);
        });
    }

    if ($('.template-suffix-artists').length > 0) {
        $('h2.name').on('mouseenter', function () {
            let opts = [
                '#d7d029',
                '#7fb6d9',
                '#ff4841',
                '#46ba67',
                '#eb88c8',
                '#ff7600'
            ];
            let rnd = opts[Math.floor(Math.random() * opts.length)];
            let borderLeft = Math.random() > 0.5 ? 'left' : 'right';
            if (borderLeft == 'left') {
                $(this).find('img').css({
                    'border-left': `3px solid ${rnd}`
                });
            } else {
                $(this).find('img').css({
                    'border-right': `3px solid ${rnd}`
                });
            }
        }).on('mouseleave', function () {
            $(this).find('img').css({
                'border': ''
            });
        });
    }

    // Only for Featured Collection page:
    // const hero = document.querySelector('.c-hero[data-playful]');
    // const media = hero?.querySelector('.c-hero__media img');
    // if (hero && media && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    //     hero.addEventListener('mousemove', (e) => {
    //         const r = hero.getBoundingClientRect(), x = ((e.clientX - r.left) / r.width - .5) * 10, y = ((e.clientY - r.top) / r.height - .5) * 6;
    //         media.style.transform = `translate3d(${x}px,${y}px,0) scale(1.1)`;
    //     });
    //     hero.addEventListener('mouseleave', () => media.style.transform = 'translate3d(0,0,0)');
    // }

    /*
    // Collections grid scroll animation to demonstrate horizontal scrolling

    $('.collections-grid').scrollLeft(window.innerWidth * 1.5);
    $('.collections-grid').addClass('smth');

    let collectionsGridAnimated = false;
    function handleCollectionsGridScrollIntoView() {
        if (collectionsGridAnimated) return;
        const grid = document.querySelector('.collections-grid');
        if (!grid) return;
        const rect = grid.getBoundingClientRect();
        if (
            rect.top < window.innerHeight &&
            rect.bottom > 0
        ) {
            collectionsGridAnimated = true;
            $('.collections-grid').animate({ scrollLeft: 0 }, 800);
            window.removeEventListener('scroll', handleCollectionsGridScrollIntoView);
        }
    }
    if (document.querySelector('.collections-grid')) {
        $(window).on('load', () => {
            window.addEventListener('scroll', handleCollectionsGridScrollIntoView);
            // In case it's already in view on load
            handleCollectionsGridScrollIntoView();
        });
    }
    */


    initView();

    initTextMarquee();
    initArtistsMarquee();

    miscBinds();

    resize();

    $(window).on('resize', resize);
});

function miscBinds() {
    $('.menu-toggle').on('click', function (e) {
        e.preventDefault();
        $('#shopify-section-header').toggleClass('tog');
    });

    $('p.the-giftcard--code').on('click', function () {
        // copy text
        let text = $(this).text();
        let input = document.createElement('input');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        $(this).addClass('copied');
        setTimeout(() => {
            $(this).removeClass('copied');
        }, 80);
    });

}

function initView() {
    $('.grid__item').each(function () {
        $(this).css({
            'top': `${Math.random() * 6}rem`,
            'left': `${Math.random() * 8 - 4}rem`
        });
    });
}

function resize() {
    window.w = window.innerWidth;
    if (window.prev_w == window.w && isTouch) return;
    let vh = window.innerHeight * 0.01;
    window.vh = vh;
    document.documentElement.style.setProperty(`--vh`, `${vh}px`);
    window.prev_w = window.innerWidth;
}

function initTextMarquee() {
    const marquees = document.querySelectorAll('[data-text-marquee]');
    if (!marquees.length) return;

    marquees.forEach((viewport) => {
        if (viewport.dataset.textMarqueeInit === '1') return;
        const track = viewport.querySelector('[data-text-marquee-track]');
        const baseGroup = track?.querySelector('.text-marquee__group');
        if (!track || !baseGroup) return;

        if (!baseGroup.dataset.textMarqueeBase) {
            baseGroup.dataset.textMarqueeBase = baseGroup.innerHTML;
        }

        const section = viewport.closest('.text-marquee');
        const SPEED_PX_PER_SEC = 40;
        let resizeFrame = null;

        const ensureSequence = () => {
            baseGroup.innerHTML = baseGroup.dataset.textMarqueeBase;
            track.querySelectorAll('.text-marquee__group--clone').forEach((clone) => clone.remove());

            const viewportWidth = viewport.clientWidth || section?.clientWidth || window.innerWidth;
            let contentWidth = baseGroup.scrollWidth;
            let safety = 0;

            while (contentWidth < viewportWidth * 1.5 && safety < 20) {
                const source = baseGroup.firstElementChild;
                if (!source) break;
                const dupe = source.cloneNode(true);
                dupe.setAttribute('aria-hidden', 'true');
                baseGroup.appendChild(dupe);
                contentWidth = baseGroup.scrollWidth;
                safety += 1;
            }

            const cloneGroup = baseGroup.cloneNode(true);
            cloneGroup.classList.add('text-marquee__group--clone');
            cloneGroup.setAttribute('aria-hidden', 'true');
            cloneGroup.querySelectorAll('.text-marquee__item').forEach((item) => {
                item.setAttribute('aria-hidden', 'true');
            });
            track.appendChild(cloneGroup);

            const baseWidth = baseGroup.scrollWidth;
            if (baseWidth > 0) {
                const duration = Math.max(8, Math.min(60, baseWidth / SPEED_PX_PER_SEC));
                track.style.setProperty('--text-marquee-duration', `${duration}s`);
            }
        };

        const recalc = () => {
            if (resizeFrame) return;
            resizeFrame = requestAnimationFrame(() => {
                ensureSequence();
                resizeFrame = null;
            });
        };

        ensureSequence();

        if (window.ResizeObserver) {
            const ro = new ResizeObserver(recalc);
            ro.observe(viewport);
            if (section) {
                ro.observe(section);
            }
            viewport._textMarqueeObserver = ro;
        }

        const handleResize = () => recalc();
        window.addEventListener('resize', handleResize);
        viewport._textMarqueeResizeHandler = handleResize;
        viewport.dataset.textMarqueeInit = '1';
    });
}

function initArtistsMarquee() {
    const sections = document.querySelectorAll('.artists-marquee');
    if (!sections.length) return;

    sections.forEach((section) => {
        section.querySelectorAll('[data-marquee-scroller]').forEach((scroller) => {
            if (scroller.dataset.marqueeInit === '1') return;
            const list = scroller.querySelector('.artists-marquee__list');
            if (!list) return;

            const shuffleItems = (nodes) => {
                for (let i = nodes.length - 1; i > 0; i -= 1) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [nodes[i], nodes[j]] = [nodes[j], nodes[i]];
                }
                return nodes;
            };

            let items = Array
                .from(list.children)
                .filter((item) => !item.classList.contains('artists-marquee__item--clone'));

            if (items.length && !list.dataset.shuffled) {
                const shuffled = shuffleItems(items);
                shuffled.forEach((item) => list.appendChild(item)); // move nodes to new order
                list.dataset.shuffled = '1';
                items = shuffled;
            }

            if (!items.length) return;

            if (scroller.dataset.duped !== '1') {
                const fragment = document.createDocumentFragment();
                items.forEach((item) => {
                    const clone = item.cloneNode(true);
                    clone.classList.add('artists-marquee__item--clone');
                    clone.setAttribute('aria-hidden', 'true');
                    clone.querySelectorAll('a, button, [tabindex]').forEach((focusable) => {
                        focusable.setAttribute('tabindex', '-1');
                    });
                    fragment.appendChild(clone);
                });
                list.appendChild(fragment);
                scroller.dataset.duped = '1';
            }

            const row = scroller.closest('.artists-marquee__row');
            const direction = row?.dataset.direction === 'right' ? -1 : 1;
            initArtistsMarqueeLoop(scroller, direction);
            scroller.dataset.marqueeInit = '1';
        });
    });
}

function initArtistsMarqueeLoop(scroller, direction) {
    const speedPxPerSec = 40;
    let duplicationFactor = scroller.dataset.duped === '1' ? 2 : 1;
    let originalWidth = duplicationFactor ? scroller.scrollWidth / duplicationFactor : scroller.scrollWidth;
    let baseScrollOffset = direction === -1 ? originalWidth : 0;
    scroller.scrollLeft = baseScrollOffset;

    const motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    let respectMotion = motionQuery ? motionQuery.matches : false;

    let paused = false;
    let userPaused = false;
    let isDragging = false;
    let dragStartX = 0;
    let dragStartScroll = baseScrollOffset;
    let dragMoved = false;
    let preventClick = false;
    let resumeTimer = null;
    let loopActive = false;
    let rafId = null;
    let loopStart = performance.now();

    const normalizeOffset = (value) => {
        if (!originalWidth) return 0;
        const mod = value % originalWidth;
        return mod < 0 ? mod + originalWidth : mod;
    };

    const applyScroll = (value) => {
        const normalized = normalizeOffset(value);
        scroller.scrollLeft = normalized;
        return normalized;
    };

    const syncBaseToCurrent = () => {
        baseScrollOffset = normalizeOffset(scroller.scrollLeft);
    };

    const tick = (now) => {
        if (!loopActive) return;

        if (!paused && !isDragging && originalWidth > scroller.clientWidth + 4) {
            const elapsed = now - loopStart;
            const distance = (speedPxPerSec * elapsed) / 1000;
            const target = applyScroll(baseScrollOffset + (distance * direction));
            baseScrollOffset = target;
            loopStart = now;
        } else {
            loopStart = now;
        }

        if (loopActive) {
            rafId = requestAnimationFrame(tick);
        }
    };

    const startLoop = () => {
        if (loopActive) return;
        loopActive = true;
        paused = false;
        loopStart = performance.now();
        rafId = requestAnimationFrame(tick);
    };

    const stopLoop = () => {
        if (!loopActive) return;
        loopActive = false;
        if (rafId) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }
    };

    const pause = (setUserPaused = false) => {
        syncBaseToCurrent();
        paused = true;
        if (setUserPaused) {
            userPaused = true;
        }
        if (resumeTimer) {
            clearTimeout(resumeTimer);
        }
    };

    const resumeSoon = (delay = 1200) => {
        if (!loopActive) return;
        if (resumeTimer) {
            clearTimeout(resumeTimer);
        }
        resumeTimer = setTimeout(() => {
            userPaused = false;
            syncBaseToCurrent();
            paused = false;
            loopStart = performance.now();
        }, delay);
    };

    const updateLoopState = () => {
        const shouldLoop = !respectMotion && originalWidth > scroller.clientWidth + 4;
        if (shouldLoop) {
            scroller.classList.add('looping');
            startLoop();
        } else {
            scroller.classList.remove('looping');
            stopLoop();
        }
    };

    const recalc = () => {
        duplicationFactor = scroller.dataset.duped === '1' ? 2 : 1;
        originalWidth = duplicationFactor ? scroller.scrollWidth / duplicationFactor : scroller.scrollWidth;
        syncBaseToCurrent();
        updateLoopState();
    };

    const pointerDown = (event) => {
        if (!event.isPrimary) return;
        if (event.button !== undefined && event.button !== 0 && event.pointerType !== 'touch') {
            return;
        }
        pause(true);
        isDragging = true;
        dragMoved = false;
        dragStartX = event.clientX;
        dragStartScroll = baseScrollOffset;
    };

    const pointerMove = (event) => {
        if (!isDragging) return;
        const delta = event.clientX - dragStartX;
        if (!dragMoved) {
            if (Math.abs(delta) > 3) {
                dragMoved = true;
                scroller.classList.add('is-dragging');
                try {
                    scroller.setPointerCapture(event.pointerId);
                } catch (err) {
                    // ignore
                }
            } else {
                return;
            }
        }
        if (dragMoved && event.pointerType === 'touch') {
            event.preventDefault();
        }
        applyScroll(dragStartScroll - delta);
    };

    const endDrag = (event) => {
        if (!isDragging) return;
        isDragging = false;
        scroller.classList.remove('is-dragging');
        try {
            scroller.releasePointerCapture(event.pointerId);
        } catch (err) {
            // ignore
        }
        syncBaseToCurrent();
        loopStart = performance.now();
        if (dragMoved) {
            preventClick = true;
            setTimeout(() => {
                preventClick = false;
            }, 200);
        }
        resumeSoon(800);
    };

    const cancelDrag = (event) => {
        if (!isDragging) return;
        isDragging = false;
        scroller.classList.remove('is-dragging');
        try {
            scroller.releasePointerCapture(event.pointerId);
        } catch (err) {
            // ignore
        }
        syncBaseToCurrent();
        loopStart = performance.now();
        resumeSoon(800);
    };

    const clickGuard = (event) => {
        if (preventClick) {
            event.preventDefault();
            event.stopImmediatePropagation();
            preventClick = false;
        }
    };

    scroller.addEventListener('pointerdown', pointerDown);
    scroller.addEventListener('pointermove', pointerMove);
    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', cancelDrag);
    window.addEventListener('pointerup', endDrag);
    scroller.addEventListener('click', clickGuard, true);
    scroller.addEventListener('dragstart', (event) => {
        event.preventDefault();
    });

    scroller.addEventListener('mouseenter', () => {
        if (isDragging) return;
        pause();
    });
    scroller.addEventListener('mouseleave', () => {
        if (isDragging) return;
        resumeSoon(50);
    });
    scroller.addEventListener('wheel', () => {
        pause(true);
        resumeSoon(1500);
    }, { passive: true });

    if (motionQuery) {
        const motionHandler = (event) => {
            respectMotion = event.matches;
            if (respectMotion) {
                pause(true);
            }
            updateLoopState();
        };
        if (motionQuery.addEventListener) {
            motionQuery.addEventListener('change', motionHandler);
        } else if (motionQuery.addListener) {
            motionQuery.addListener(motionHandler);
        }
    }

    const ro = window.ResizeObserver ? new ResizeObserver(recalc) : null;
    if (ro) {
        ro.observe(scroller);
    }
    window.addEventListener('resize', recalc);
    window.addEventListener('orientationchange', recalc);

    recalc();
}

document.addEventListener('shopify:section:load', initArtistsMarquee);
document.addEventListener('shopify:section:load', initTextMarquee);
document.addEventListener('shopify:section:load', initDragScrollContainers);
document.addEventListener('shopify:section:load', initLatestRecentSections);
document.addEventListener('shopify:section:unload', (event) => {
    const unloadedSection = event.target;
    if (!unloadedSection) return;
    unloadedSection.querySelectorAll('[data-text-marquee]').forEach((viewport) => {
        if (viewport._textMarqueeObserver) {
            viewport._textMarqueeObserver.disconnect();
            delete viewport._textMarqueeObserver;
        }
        if (viewport._textMarqueeResizeHandler) {
            window.removeEventListener('resize', viewport._textMarqueeResizeHandler);
            delete viewport._textMarqueeResizeHandler;
        }
        delete viewport.dataset.textMarqueeInit;
    });
    unloadedSection.querySelectorAll('[data-drag-scroll]').forEach((container) => {
        if (container._dragScrollCleanup) {
            container._dragScrollCleanup();
            delete container._dragScrollCleanup;
        }
        delete container.dataset.dragScrollInit;
    });
});
